import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
	HttpService,
	GET,
	Adapter,
	POST,
	Body,
	Query,
} from "@royalty/httpclient";
import { SmartSearchModel } from "src/app/core/smartsearch/smartsearch";
import { EditDiscount, NewDiscount } from "@royalty/model";
import { DiscountSearchModel } from "src/app/components/admin/configuration/discount/model/discount";

@Injectable()
export class DiscountService extends HttpService {
	@GET("discount/list")
	@Adapter(null, { isAdmin: true })
	getAllDiscounts(): Observable<any> {
		return null;
	}
	@POST("discount/list")
	@Adapter(null, { isAdmin: true })
	getDiscounts(@Body data: DiscountSearchModel): Observable<any> {
		return null;
	}

	@GET("discount/getById")
	@Adapter(null, { isAdmin: true })
	getDiscount(@Query("id") id: number): Observable<any> {
		return null;
	}

	@POST("discount/adminCreateDiscount")
	@Adapter(null, { isAdmin: true })
	createDiscount(@Body data: NewDiscount): Observable<any> {
		return null;
	}

	@POST("discount/adminUpdateDiscount")
	@Adapter(null, { isAdmin: true })
	updateDiscount(@Body data: EditDiscount): Observable<any> {
		return null;
	}

	@GET("discount/adminDeleteDiscount")
	@Adapter(null, { isAdmin: true })
	deleteDiscount(@Query("id") id: number): Observable<any> {
		return null;
	}
}
